interface PromoApplyResponse {
  redirectLink?: string
}

export const getPromoRedirectUrl = (resp?: PromoApplyResponse): string | null => resp?.redirectLink || null
